import { Trans } from 'react-i18next';
import { Link } from 'react-router-dom';
import styles from '../../styles.module.scss';
import cn from 'classnames';

type Props = {
    active?: boolean;
    handleToggle?: () => void;
    className?: string;
};

export const MenuPublications: React.FC<Props> = ({ active, handleToggle, className }) => (
    <div className={cn(className, styles.tooltipContent)}>
        <Link className={styles['navbar-item']} to="/news" onClick={active ? handleToggle : undefined}>
            <Trans i18nKey="menuNews" />
        </Link>
        <Link className={styles['navbar-item']} to="/articles" onClick={active ? handleToggle : undefined}>
            <Trans i18nKey="menuArticles" />
        </Link>
    </div>
);
